import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web--source/common/localization";

import { SelfServeNodes } from "../../../types";
import { cancelOrder } from "../../instantAnswers/orders-cancelOrder";
import { orderCanceledStateVisibilityFn } from "../../visibilityFunctions/orderStateVisibilityFn";

export const useOrderCanceledBrandNodes = (): SelfServeNodes => {
  const { strictLocalize } = useStrictLocalization();
  const articles = useArticles();
  return {
    WhyWasThisCanceledCanceledState: {
      id: "WhyWasThisCanceledCanceledState",
      label: strictLocalize({
        defaultMessage: "Why was this canceled?",
        description: {
          text: "A node in the Orders section of the full page self-serve experience of Faire's Help Center",
        },
      }),
      level: 2,
      isNodeVisible: orderCanceledStateVisibilityFn,
      instantAnswer: cancelOrder(strictLocalize),
      articles: [
        articles.FulfillingOrders.UNDERSTAND_ORDER_STATUS,
        articles.FulfillingOrders.CAN_RETAILER_CANCEL_ORDER,
        articles.FulfillingOrders.FULFILLING_ORDER,
      ],
    },
    OtherCanceledState: {
      id: "OtherCanceledState",
      label: strictLocalize({
        defaultMessage: "Other",
        description: {
          text: "A node in the Orders section of the full page self-serve experience of Faire's Help Center",
        },
      }),
      level: 2,
      isNodeVisible: orderCanceledStateVisibilityFn,
      articles: [articles.FulfillingOrders.FULFILLING_ORDER],
    },
  };
};
